import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { Keni } from '@/components/atoms/Keni/Keni';

export const OfflineContent = ({}: OfflineContentProps) => {
  return (
    <Stack
      sx={{
        height: '100%',
        maxHeight: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        p: sp[32],
      }}
    >
      <Box sx={{ maxWidth: '112px', mb: sp[20] }}>
        <Keni emotion='offline' direction='right' />
      </Box>
      <Box
        sx={{
          color: '#003413',
          fontFamily: 'Lora, serif',
          fontSize: '2rem',
          lineHeight: 1.5,
          fontWeight: 400,
        }}
      >
        No Connection
      </Box>
      <Box
        sx={{
          textAlign: 'center',
          mt: sp[32],
          color: '#404042',
          typography: 'bodyMd',
        }}
      >
        It looks like you're offline. Please check your internet connection{' '}
      </Box>
    </Stack>
  );
};

interface OfflineContentProps {}

OfflineContent.displayName = 'OfflineContent';

export default OfflineContent;
